'use strict';
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftStatusAlert', function() {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          'success': '@',
          'fail': '@',
          'term1': '@',
          'desc1': '@',
          'dest1': '@',
          'term2':'@',
          'desc2':'@',
        },
        templateUrl: 'views/common/statusalert.html',
        link:function link(scope, element, attrs) {
          scope.term1 = attrs.term1;
          scope.desc1 = attrs.desc1;
          scope.dest1 = attrs.dest1;
          scope.term2 = attrs.term2;
          scope.desc2 = attrs.desc2;
          scope.inlineStyle1 = {};
          scope.inlineStyle2 = {};

          if(scope.term1 == undefined) scope.inlineStyle1 = {'margin-left':'0px'};
          if(scope.term2 == undefined) scope.inlineStyle2 = {'margin-left':'0px'};
        },
        controller: function($scope) {
          $scope.success = false;
          $scope.fail = false;
        }
      };
    });
})(angular);

